import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { GeneralDialogModel } from './general-dialog.model';
import { DomSanitizer, SafeHtml  } from '@angular/platform-browser';

@Component({
    selector: 'general-dialog',
    templateUrl: 'general-dialog.component.html',
    styleUrls: ['./general-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatDialogModule, MatButtonModule]
})

export class GeneralDialogComponent {
    public safeHtmlContent!: SafeHtml;

    constructor(
      public dialogRef: MatDialogRef<GeneralDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: GeneralDialogModel,
      private sanitizer: DomSanitizer
    ) {}

  ngOnInit() {
    if (this.data.dialogContent) {
      this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.data.dialogContent);
    }    
    else {
      this.safeHtmlContent=""
    }
  }
  
}